<template>
  <div>
    <search-form @trackStatusChange="handleTrackStatusChange" @handleSearch="handleSearch" ref="searchForm" :searching="searching"></search-form>

    <div class="list-wrapper" v-loading="searching">
      <div class="export-btn-wrapper">
        <el-button type="primary" :loading="exporting" @click="handleExport">导出所选部分数据</el-button>
        <span class="table-tip" v-if="trackStatus === 'stored'">如对版权信息有疑问，请提交反馈或直接联系对接商务。</span>
      </div>

      <template v-if="trackStatus==='checking'">
        <CheckingList :raw-data="tableData"></CheckingList>
      </template>
      <template v-else>
        <StoredList :raw-data="tableData"></StoredList>
      </template>
      <el-pagination
        @size-change="handleSearch"
        @current-change="fetchData"
        :page-sizes="[10, 20, 50, 100]"
        :current-page.sync="pagination.current"
        :page-size.sync="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        class="track-pagination-bottom"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import trackService from '@/api/track'
import CheckingList from './components/List/CheckingList.vue'
import StoredList from './components/List/StoredList.vue'
import SearchForm from './components/SearchForm/SearchForm.vue'

export default {
  name: 'TrackManage',

  components: {
    CheckingList,
    StoredList,
    SearchForm
  },

  data() {
    return {
      trackStatus: 'stored',
      searching: false,
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: [],
      fetchFn: trackService.querySettlementData.bind(trackService),
      exporting: false
    }
  },

  methods: {
    handleTrackStatusChange(v) {
      this.trackStatus = v

      if (v === 'checking') {
        this.fetchFn = trackService.find.bind(trackService)
      } else {
        this.fetchFn = trackService.querySettlementData.bind(trackService)
      }
      this.pagination.total = 0
      this.pagination.size = 10
      this.handleSearch()
    },
    handleSearch() {
      this.pagination.current = 1
      this.fetchData()
    },
    async fetchData() {
      const { pagination } = this
      const searchData = {
        page: pagination.current - 1,
        num: pagination.size,
        ...this.$refs.searchForm.getSearchData()
      }
      this.searching = true
      try {
        const { list, total } = await this.fetchFn(searchData)
        this.tableData = list
        this.pagination.total = total
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.searching = false
      }
    },
    // 导出
    async handleExport() {
      this.exporting = true
      this.$notify({
        title: '通知',
        showClose: true,
        message: '正在生成导出任务,请关注邮件或站内通知...',
        position: 'top-right',
        iconClass: 'el-icon-loading',
        duration: 2000
      })

      try {
        await trackService[this.trackStatus === 'stored' ? 'exportAllSettlementData' : 'exportAllData'](this.$refs.searchForm.getSearchData())
      } catch (err) {
        this.$message.error(err.message)
      } finally {
        this.exporting = false
      }
    },
  }
}
</script>
<style scoped>
.list-wrapper{
  background: #fff;
  padding: 16px;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.1);
}

.export-btn-wrapper{
  float: left;
}
.track-pagination,.track-pagination-bottom{
  margin-bottom: 10px;
  text-align: right;
}
.track-pagination-bottom{
  margin-top: 10px;
  margin-bottom: 0;
}
</style>
